import Button from "../Button/Button";
import { Modal } from "react-bootstrap";
import { ModalWrapper } from "./ModalWrapperStyle";
import "./BootstrapModal.scss";
export const BootstrapModal = ({
  modaltitle,
  children,
  handleClose,
  show,
  moreButton,
  size,
  closebutton,
}) => {
  return (
    <ModalWrapper>
      <Modal
        size={size}
        show={show}
        onHide={handleClose}
        dialogClassName={"custom-class"}
      >
        <Modal.Header>
          {closebutton}
          <Modal.Title>{modaltitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>

        {moreButton ? (
          <>
            <Modal.Footer>
              <Button variant="primary" onclick={handleClose}>
                Save Changes
              </Button>
            </Modal.Footer>
          </>
        ) : null}
      </Modal>
    </ModalWrapper>
  );
};
